<script>
  import RangeSlider from 'svelte-range-slider-pips';
  import { Col, Label, Row } from 'sveltestrap';
  import { PipsLable } from '../../../utils/Constant/Constant';
</script>
<Row class="form-group">
    <Label class="col-md-2 sm-left-text">{PipsLable}</Label>
    <Col md="10">
      <RangeSlider pips pipstep="20" all="label" float />
    </Col>
</Row>